<template>
<v-navigation-drawer
    v-if="isActive"
    :hide-overlay="true"
    class="drawer-disable-scrollbar"
    width="370"
    permanent
    right
    app
    clipped
    touchless
  >
    <v-layout column id="unitSidebar">
      <HeaderImage
        :loading="entity.loading"
        :name="entity.name"
        :shortName="entity.short_name"
        :subVendorName="entity.business"
        :shouldDisplay="entity"
        :position="marker.position"
        @close="$emit('close')"
      />

      <Toolbar v-if="isMissing" :item="marker" style="z-index: 10;"/>

      <Loader
        :size="35"
        :yes="entity.loading"
        style="padding: 2rem 0"
      />

      <v-tabs v-if="entity.loading === false">
        <v-tabs-slider color="secondary"></v-tabs-slider>
        <v-tab  class="text--primary">
          {{ t({s: 'sidebar.information.title', component: 'Map'}) }}
        </v-tab>
        <v-tab class="text--primary">
          {{ t({s: 'sidebar.trips.title', component: 'Map'}) }}
        </v-tab>
        <v-tab-item>
          <InformationPane :showError="entity.hasOwnProperty('error') && !isMissing" :entity="entity" :marker="marker"/>
        </v-tab-item>
        <v-tab-item>
          <TripsPane :entity="entity" @loaded="v => $emit('trips', v)"/>
        </v-tab-item>
      </v-tabs>
    </v-layout>
  </v-navigation-drawer>
</template>

<script lang="js" type="es6">
import TripsPane from '@/components/Google/SelectedMarker/TripsPane'
import HeaderImage from '@/components/Google/SelectedMarker/HeaderImage'
import InformationPane from '@/components/Google/SelectedMarker/InformationPane'
import Toolbar from '@/components/Google/Toolbar'
import Loader from '@/components/Global/Loader'

import { mapState } from 'vuex'

export default {
  name: 'SelectedMarker',
  components: { Toolbar, TripsPane, HeaderImage, InformationPane, Loader },
  props: {
    imei: String,
    marker: Object,
    isActive: Boolean
  },
  computed: {
    ...mapState('Map', ['drawer']),
    entity () { return this.drawer?.entity || {} },
    open () { return Object.keys(this.entity).length > 0 },
    isMissing () { return this.$route.name === 'missing' }
  },
  watch: {
    marker (m) {
      this.$store.commit('Map/findEntity', { id: m?.id, axios: this.axios, isMissing: this.isMissing })
    }
  }
}
</script>

<style scoped>
    @import './styles.css';
</style>
